import { urlUtils } from '../utils/url';
import { format, parseUrlDate } from '../utils/date/dateUtils';

const cruiseModel = {
  get sessionId() {
    return urlUtils.getSessionIdFromUrl();
  },
  get rooms() {
    return urlUtils.getRoomDistributionFromUrl();
  },
  get departureAirportId() {
    return urlUtils.getDepartureIdFromUrl();
  },
  get departureAirportWvId() {
    return urlUtils.getDepartureWvIdFromUrl();
  },
  get resortId() {
    const resortId = urlUtils.getResortIdFromUrl();
    return resortId === '-1' ? '' : resortId;
  },
  get areaId() {
    const areaId = urlUtils.getAreaIdFromUrl();
    return areaId === '-1' ? '' : areaId;
  },
  get departureDate() {
    const departureDate = urlUtils.getDepartureDateFromUrl();

    if (!departureDate) {
      return null;
    }

    const parsedDepartureDate = parseUrlDate(urlUtils.getDepartureDateFromUrl());
    return format(parsedDepartureDate, '-');
  },
  get returnDate() {
    const returnDate = urlUtils.getReturnDateFromUrl();

    if (!returnDate) {
      return null;
    }

    const parsedReturnDate = parseUrlDate(urlUtils.getReturnDateFromUrl());
    return format(parsedReturnDate, '-');
  },
  get tdmRuleId() {
    return urlUtils.getTdmRuleIdFromUrl();
  },
  get selectedCabin() {
    return urlUtils.getSelectedCabinFromUrl();
  },
  get cruiseCode() {
    return urlUtils.getCruiseCodeFromUrl();
  },
  get cruiseId() {
    return urlUtils.getCruiseIdFromUrl();
  },
  get accomodationKeys() {
    return urlUtils.getAccommodationKeysFromUrl();
  },
  get transportKey() {
    return urlUtils.getTransportKeyFromUrl();
  },
  get transportId() {
    return urlUtils.getTransportIdFromUrl();
  },
  get tripContext() {
    return urlUtils.getTripContextFromUrl();
  },
  get CabinClass() {
    return urlUtils.getCabinClassFromUrl();
  },
  get DirectFlight() {
    return urlUtils.getFastestFlightFromUrl();
  },
  get IncludeBaggage() {
    return urlUtils.getIncludeBaggageFromUrl();
  },
};

export default cruiseModel;
